import ApiStore   from './store';
import ApiActions from './actions-factory';

export default {
  store: ApiStore,
  actions: ApiActions
}



// WEBPACK FOOTER //
// ./medscape_modules/qna/api/index.js